

function PrintPage({ organization, token, close }) {

    const handlePreview = () => {
        const content = document.getElementById("formContent").innerHTML;
        const win = window.open("", "", "width=900,height=700");
        win.document.write(`
        <html>
            <head>
             <title>پیش‌نمایش فرم API</title>
             <style>
                 @font-face {
                  font-family: 'BNazanin';
                  src: url('./Fonts/BNAZANIN.TTF') format('truetype');
                   }
                  body {
                     font-family: 'BNAZANIN', Tahoma, sans-serif;
                     direction: rtl;
                     text-align: right;
                     line-height: 1.8;
                     padding: 20px;
                 }
             </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
        win.document.close();
    };

    const handlePrint = () => {
        const content = document.getElementById("formContent").innerHTML;
        const win = window.open("", "", "width=900,height=700");
        win.document.write(`
    <html>
      <head>
        <title>پرینت فرم API</title>
        <style>
          @font-face {
            font-family: 'BNazanin';
            src: url('/Fonts/BNAZANIN.TTF') format('truetype');
          }
          @font-face {
            font-family: 'IRANSansXFaNumMedium';
            src: url('/Fonts/IRANSansXFaNum-Medium.ttf') format('truetype');
          }
          body {
            font-family: 'IRANSansXFaNumMedium', BNazanin, Tahoma, sans-serif;
            direction: rtl;
            text-align: right;
            line-height: 1.8;
            padding: 20px;
          }
        </style>
      </head>
      <body>${content}</body>
    </html>
  `);
        win.document.close();

        // ⏳ کمی صبر کن تا محتوا لود بشه، بعد پرینت کن
        win.onload = () => {
            setTimeout(() => {
                win.focus();
                win.print();
            }, 500);
        };
    };


    // const handlePrint = () => {
    //     const content = document.getElementById("formContent").innerHTML;
    //     const win = window.open("", "", "width=900,height=700");
    //     win.document.write(`
    //   <html>
    //     <head>
    //       <title>پرینت فرم API</title>
    //       <style>
    //              @font-face {
    //               font-family: 'BNazanin';
    //               src: url('./Fonts/BNAZANIN.TTF') format('truetype');
    //                }
    //               @font-face {
    //                 font-family: 'IRANSansXFaNumMedium';
    //                  src: local('IRANSansXFaNum-Medium'), url("./Fonts/IRANSansXFaNum-Medium.ttf") format(truetype)
    //                 }
    //               body {
    //                  font-family: 'IRANSansXFaNumMedium',BNazanin, Tahoma, sans-serif;
    //                  direction: rtl;
    //                  text-align: right;
    //                  line-height: 1.8;
    //                  padding: 20px;
    //              }
    //          </style>
    //     </head>
    //     <body>
    //       ${content}
    //     </body>
    //   </html>
    // `);
    //     win.document.close();
    //     win.print();
    // };

    return (
        <>
            <div className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40" onClick={() => close(false)}></div>
            <div className="fixed top-[50%] h-5/6 overflow-auto left-1/2 transform -translate-x-1/2 -translate-y-1/2 pb-10 bg-primary-100 rounded-lg px-14 py-10 text-right rtol">
                <img src="/image/icon/close.png" className="w-5 cursor-pointer absolute top-10 left-10" onClick={() => close(false)} />
                <p className="text-lg font-bold mb-4">فرم استفاده از API پیام‌رسان بوستان</p>
                <div className="flex justify-between w-full my-4">
                    <button className="bg-primary-500 text-white text-center py-2 w-40 rounded-lg" onClick={handlePreview}>مشاهده PDF</button>
                    <button className="bg-primary-500 text-white text-center py-2 w-40 rounded-lg" onClick={handlePrint}>پرینت PDF</button>
                </div>
                <div id="formContent" className="bg-slate-100 p-10 leading-9 text-sm font-BNAZANIN">
                    <h3 className="font-bold text-lg">مجموعه مقررات و راهنمای دریافت و استفاده از توکن API پیام‌رسان بوستان</h3>
                    <strong>مقدمه:</strong>
                    <p> این سند، مجموعه‌ای از مقررات و راهنمای استفاده از API پیام‌رسان بوستان را برای شرکت‌ها ارائه می‌دهد. هدف حفظ امنیت، حریم خصوصی کاربران و اطمینان از استفاده صحیح و اخلاقی است.</p>

                    <h4 className="font-bold">۱. شرایط و ضوابط عمومی</h4>
                    <ul>
                        <li>استفاده از API بوستان منوط به پذیرش و رعایت کامل این مجموعه مقررات است.</li>
                        <li>بوستان حق دارد در هر زمان و بدون اطلاع قبلی، این مجموعه مقررات را تغییر دهد.</li>
                        <li>شرکت استفاده‌کننده موظف است قوانین و مقررات جاری کشور و حفاظت داده‌ها را رعایت کند.</li>
                        <li>بوستان حق دارد در صورت تخلف، دسترسی به API را قطع کند.</li>
                        <li>پیام رسان بوستان حق نظارت بر فعالیت‌های شرکت <strong>{organization || "%Organization%"}</strong> را دارد.</li>
                    </ul>
                    <br />
                    <h4 className="font-bold">۲. شرایط و ضوابط مربوط به دریافت توکن</h4>
                    <p>برای استفاده از API بوستان، شرکت‌ها باید ابتدا یک توکن اختصاصی دریافت کنند و اطلاعات کامل ارائه دهند.</p>
                    <ul>
                        <li>نام شرکت</li>
                        <li>شناسه ملی شرکت</li>
                        <li>زمینه فعالیت شرکت</li>
                        <li>آدرس وب‌سایت شرکت</li>
                        <li>نام و نام خانوادگی نماینده قانونی</li>
                        <li>شماره تماس نماینده قانونی</li>
                        <li>آدرس ایمیل نماینده قانونی</li>
                        <li>توضیح مختصر نحوه استفاده از API و هدف ارسال پیام‌ها</li>
                        <li>بوستان پس از بررسی درخواست و اطمینان از صحت اطلاعات ارائه شده، یک توکن اختصاصی در اختیار شرکت قرار می‌دهد.</li>
                    </ul>
                    <br />

                    <h4 className="font-bold">۳. شرایط و ضوابط مربوط به استفاده از توکن</h4>
                    <ul>
                        <li>توکن ارائه شده اختصاصی و غیرقابل انتقال است.</li>
                        <li>شرکت موظف است از توکن محافظت کند و در صورت افشا، بوستان را مطلع کند.</li>
                        <li>توکن دارای تاریخ انقضا است و پس از آن باید تمدید شود.</li>
                        <li>توکن ارائه شده: <strong>{token || "%Token%"}</strong></li>
                    </ul>

                    <h4 className="font-bold">۴. شرایط و ضوابط مربوط به محتوای پیام‌ها</h4>
                    <ul>
                        <li>محتوا باید مطابق قوانین کشور و حفاظت داده‌ها باشد.</li>
                        <li>ارسال پیام‌های تبلیغاتی ناخواسته (Spam) ممنوع است.</li>
                        <li>پیام‌ها نباید توهین‌آمیز، غیراخلاقی، تهدیدآمیز یا حاوی اطلاعات نادرست باشند.</li>
                        <li>شرکت مسئولیت کامل محتوای پیام‌ها را بر عهده دارد.</li>
                        <li>بوستان حق جلوگیری از ارسال پیام نامناسب را دارد.</li>
                    </ul>

                    <h4 className="font-bold">۵. راهنمای استفاده از API</h4>
                    <p>مستندات کامل API بوستان در وبسایت قابل دسترس است.</p>

                    <h4 className="font-bold">۶. امضا</h4>
                    <p>اینجانب ........................ نماینده قانونی شرکت <strong>{organization || "%Organization%"}</strong>، با مطالعه دقیق مجموعه مقررات و راهنمای استفاده از API پیام‌رسان بوستان، متعهد می‌گردم که تمامی مفاد آن را رعایت نمایم.</p>
                    <p>تاریخ: ............................................</p>
                    <p>امضا و مهر شرکت: ...................................</p>
                </div>
            </div>
        </>
    )
}
export default PrintPage;